import React from 'react';

/**
 * @deprecated, use @ott/icon-chevron-right, @ott/icon-small-chevron-right, @ott/icon-check or @ott/icon-small-check instead
 */
function SelectArrowIcon({ className, h, w, style, fill }) {
  return (
    <svg
      className={className}
      width={w}
      height={h}
      viewBox="0 0 24 14.8"
      fill="#222"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g fill={fill}>
        <path d="M2.8,0L12,9.2L21.2,0L24,2.8l-12,12L0,2.8L2.8,0z" />
      </g>
    </svg>
  );
}

SelectArrowIcon.defaultProps = {
  w: 24,
  h: 14.8,
  fill: '#000',
};

SelectArrowIcon.IS_DEPRECATED = true;

export default SelectArrowIcon;
